import { createPayLoadDateTime } from 'utils/dateAndTimeUtils';

export default {
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.StartInputs.TimeDropdown': ({ selectedOptionId, startTime, endH, endTime }, _, internalStateSetter) => {
    let startDate = createPayLoadDateTime({ time: selectedOptionId, date: startTime });
    let endDate = createPayLoadDateTime({ time: endH, date: endTime });

    if (startDate > endDate) {
      internalStateSetter({ startH: selectedOptionId, endH: selectedOptionId, endTime: startTime });
    } else {
      internalStateSetter({ startH: selectedOptionId });
    }
  },
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.StartInputs.Calendar': ({ selectedDate, startH, endH, endTime }, _, internalStateSetter) => {
    let startDate = createPayLoadDateTime({ time: startH, date: selectedDate });
    let endDate = createPayLoadDateTime({ time: endH, date: endTime });

    if (startDate > endDate) {
      internalStateSetter({ startTime: selectedDate, endTime: selectedDate, endH: startH });
    } else {
      internalStateSetter({ startTime: selectedDate });
    }
  },
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.EndInputs.TimeDropdown': ({ selectedOptionId, startH, startTime, endTime }, _, internalStateSetter) => {
    let startDate = createPayLoadDateTime({ time: startH, date: startTime });
    let endDate = createPayLoadDateTime({ time: selectedOptionId, date: endTime });

    if (startDate > endDate) {
      internalStateSetter({ startH: selectedOptionId, endH: selectedOptionId, startTime: endTime });
    } else {
      internalStateSetter({ endH: selectedOptionId });
    }
  },
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.EndInputs.Calendar': ({ selectedDate, startH, startTime, endH }, _, internalStateSetter) => {
    let startDate = createPayLoadDateTime({ time: startH, date: startTime });
    let endDate = createPayLoadDateTime({ time: endH, date: selectedDate });

    if (startDate > endDate) {
      internalStateSetter({ startTime: selectedDate, endTime: selectedDate, startH: endH });
    } else {
      internalStateSetter({ endTime: selectedDate });
    }
  },
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.Assign': ({ selectedTechId, selectedVendorId }, _, internalStateSetter) => {
    internalStateSetter({ assignedTechId: selectedTechId, assignedVendorId: selectedVendorId });
  },
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.ButtonsWrapper.Save': ({ startDate, endDate, assignedTechId, assignedVendorId, disabled }, outlet) => {
    if (disabled) return;
    outlet({ startDate, endDate, assignedTechId, assignedVendorId, action: 'save' })
  },
  'TimeTrackerDropdown.DropdownWrapper.Wrapper.ButtonsWrapper.Cancel': ({ }, outlet) => {
    outlet({ action: 'cancel' })
  },
}
